import React from "react";
import { Router } from "react-router-dom";
import { ApolloProvider } from "react-apollo";
import { client } from "./client/client";
import { store } from "./redux/store";
import { updateActiveItem } from "./src/actions/globalActions";
import { StripeProvider } from "react-stripe-elements";

exports.replaceRouterComponent = ({ history }) => {
  const ConnectedRouterWrapper = ({ children }) => (
    <StripeProvider apiKey="pk_test_uNWjlfbUWZxMqNTgejG8ixkh">
      <ApolloProvider store={store} client={client}>
        <Router history={history}>{children}</Router>
      </ApolloProvider>
    </StripeProvider>
  );

  return ConnectedRouterWrapper;
};
exports.onRouteUpdate = ({ location }) => {
  store.dispatch(updateActiveItem(location.pathname));
  // return obj;
  // return location;
};



// WEBPACK FOOTER //
// ./gatsby-browser.js